import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";
import { Localvalue } from "../../nametitle/localValue";
import { toast } from "react-toastify";



export const AuthUser = async (username , password , setState,redirect) => {
    var data = JSON.stringify({
        "username": username,
        "password": password,
    });
    var config = {
        method: 'post',
        url: `${baseUrl.baseUrl}/api/v1/auth/login/`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: data
    };
    await axios(config)
        .then(function (response) {
            //console.log(JSON.stringify(response.data));
            sessionStorage.setItem(Localvalue.access , `${response.data.key}`);
            sessionStorage.setItem(Localvalue.namelogin , `${response.data.data.firstname} ${response.data.data.lastname}`);
            sessionStorage.setItem(Localvalue.idlogin , `${response.data.data._id}`);
            redirect(`/${AllRoutes.admin}`);
        })
        .catch(function (error) {
            // alert("Authentification failed")
            toast.error("Connexion echoué")
            //console.log(error);
            setState("nom d'utilisateur ou mot de passe incorrect !")
        });
}




export const DiconnectUser = async (id) => {
    
    var config = {
        method: 'post',
        url: `${baseUrl.baseUrl}/api/v1/auth/disconnect/${id}`,
        headers: {
            'Content-Type': 'application/json',
        }
    };
    await axios(config)
        .then(function (response) {
            //console.log(response.data.message);
            localStorage.removeItem(Localvalue.access);
            window.location.reload();
        })
        .catch(function (error) {
            //console.log(error);
        });
}